import { formatCityState } from '@/Infrastructure/Utilities/string.formatter';
import { useLazyFetchLocationsQuery } from '@api/Trinium/Endpoints/Location/slice';
import useCurrentTerminal from '@hooks/useCurrentTerminal';
import useDebouncer from '@hooks/useDebounce';
import { useMemo, useState } from 'react';
import LookupList from './LookupList';
import { LookupProps, minimumSearchLength } from './types';

export default function LocationLookup(props: LookupProps) {
  const { number: terminalNumber } = useCurrentTerminal();
  const [fetchLocations, { data, isFetching }] = useLazyFetchLocationsQuery();
  const [search, setSearch] = useState('');

  useDebouncer(
    () => {
      if (search.length >= minimumSearchLength) void fetchLocations({ terminalNumber, startsWith: search });
    },
    [search, terminalNumber],
    500
  );

  const items = useMemo(
    () =>
      (data ?? []).map((location) => ({ id: location.id, name: location.name, detail: formatCityState(location.city, location.state) })),
    [data]
  );

  return (
    <LookupList
      {...props}
      items={items}
      isLoading={isFetching}
      onSearch={setSearch}
    />
  );
}
